import { FunctionComponent, useContext, useEffect } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'

import { NavigationContext } from '@/context/navigation-context'
import { path } from '@/navigation'

const ErrorRedirect: FunctionComponent = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { error, setError } = useContext(NavigationContext)
  const isLoginPage = pathname === path.loginPage

  useEffect(() => {
    if (error === 'UNAUTHORISED') {
      !isLoginPage && navigate(path.loginPage) // Redirect to the desired path
      setError(null) // Reset the error state after handling the error
    }
  }, [error, navigate, setError, isLoginPage])

  return null
}

export default ErrorRedirect
